import React from 'react';

interface Student {
  id: string;
  name: string;
  avatar: string;
}

interface TodaysSquadModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedStudents: Student[];
  onConfirm: () => void;
  isAwarding?: boolean;
}

const TodaysSquadModal: React.FC<TodaysSquadModalProps> = ({
  isOpen,
  onClose,
  selectedStudents,
  onConfirm,
  isAwarding = false
}) => {
  if (!isOpen) return null;

  const today = new Date();
  const dateString = `${today.getMonth() + 1}/${today.getDate()}`;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="todays-squad-modal-overlay" onClick={handleOverlayClick}>
      <div className="todays-squad-modal" style={{ display: 'flex', flexDirection: 'column' }}>
        <div className="todays-squad-modal-header">
          <h2>Today's Squad</h2>
          <div className="musecash-reward">
            <span className="musecash-amount">+100</span>
            <span className="musecash-icon">💰</span>
            <span className="musecash-label">Musecash</span>
          </div>
        </div>
        
        <div className="todays-squad-content" style={{ overflowY: 'auto', flexGrow: 1 }}>
          <div className="selected-students-grid">
            {selectedStudents.map((student) => (
              <div key={student.id} className="todays-squad-student-item">
                <div className="todays-squad-avatar-container">
                  <img
                    src={student.avatar}
                    alt={student.name}
                    className="todays-squad-avatar"
                  />
                  <div className="celebration-sparkle">✨</div>
                </div>
                <span className="todays-squad-student-name">{student.name}</span>
              </div>
            ))}
          </div>
        </div>
        
        <div className="todays-squad-footer" style={{ flexShrink: 0, padding: '1rem 2rem' }}>
          <button
            className="confirm-squad-btn"
            onClick={handleConfirm}
            disabled={isAwarding}
          >
            {isAwarding ? (
              <>
                <span className="loading-spinner">🔄</span>
                Awarding Musecash...
              </>
            ) : (
              "Let's Go!"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TodaysSquadModal;